import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-diangonal-right",
  "use": "arrow-diangonal-right-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"arrow-diangonal-right\"><path d=\"M13 3H8.5S8 3 8 3.5s.498.503.5.5h2.785L3.8 11.485l.707.707L12 4.7v2.807c.004.056.033.495.5.495.5 0 .5-.501.5-.501V3z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol